export function TextAreaField({ id, label, error, testId, limit, value, optional = false, ...rest }) {
  const remaining = limit - value.trim().length;
  return (
    <div className="space-y-2">
      <label htmlFor={id} className="mw-eyebrow flex items-center justify-between">
        <span>{label}</span>
        {optional && <span className="normal-case tracking-normal text-muted-foreground/70">Optional</span>}
      </label>
      <textarea
        id={id}
        data-testid={testId}
        aria-invalid={Boolean(error)}
        aria-describedby={`${id}-counter`}
        className={`mw-input mw-textarea ${error ? "border-destructive focus:border-destructive" : ""}`}
        value={value}
        {...rest}
      />
      <div className="flex items-start justify-between gap-4 text-xs">
        <p data-testid={`${testId}-error`} className="text-destructive">{error}</p>
        <p id={`${id}-counter`} data-testid={`${testId}-counter`} className={`shrink-0 font-mono ${remaining < 0 ? "text-destructive" : "text-muted-foreground"}`}>
          {remaining} left
        </p>
      </div>
    </div>
  );
}
